<template>
  <div class="popup-overlayer">
    <div class="popup">
      <a @click="$emit('close')" href="javascript:void(0)" class="close-btn"><i class="fas fa-times"></i></a>
      <h2>Normál üzemmódra állítás</h2>
      <inputbox :datepicker="{enableTime:true}" label="Időpont" :errors="errors" id="back_to_normal_datetime" name="back_to_normal_datetime" v-model="back_to_normal_datetime"/>

      <div class="align-right">
        <button @click="save" class="button" type="button" :disabled="loading">
          <i v-if="loading" class="fa fa-spinner fa-pulse fa-fw"></i>
          <span v-else>Mentés</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  props: {
    normal_mode_popup_element_id: {
      type: [Number, String, Boolean],
      required: true
    }
  },
  data() {
    return {
      loading: false,
      back_to_normal_datetime: '',
      errors: []
    };
  },
  mounted() {
    var _this = this;
  },

  methods: {
    save: function() {
      var _this = this;

      this.errors = [];

      if (this.back_to_normal_datetime == '')
        this.errors.push({
          id: 'back_to_normal_datetime',
          msg: 'Kötelező'
        });

      if (this.errors.length > 0)
        return;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('remote_open/to_normal_mode/' + _this.$root.user.apikey, {
          method: 'POST',
          data: {
            element_id: _this.normal_mode_popup_element_id,
            datetime: _this.back_to_normal_datetime,
            now: 0
          },
          success: function(response) {
            _this.$emit('save');
          }
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// normal_mode_popup.vue?f858aa3e